var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeOffWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "u6nx5woq5a",
    d: "M2.766 2.766c.463-.463 1.212-.47 1.682-.014h.002l2.136 2.137C8.264 4.039 10.119 3.597 12 3.6c5.374 0 9.922 3.532 11.45 8.4-.718 2.28-2.1 4.294-3.97 5.784l1.768 1.768c.455.47.449 1.219-.014 1.682-.463.463-1.212.47-1.682.014l-16.8-16.8c-.455-.47-.449-1.219.014-1.682zm.036 5.128L7.21 12.3c.151 2.414 2.076 4.338 4.49 4.49l3.245 3.245c-.942.238-1.929.364-2.945.364-5.372 0-9.922-3.532-11.45-8.4.473-1.504 1.238-2.9 2.252-4.106zm6.964-.143l-.204.113 1.816 1.818c.829-.22 1.711.017 2.317.623.606.606.843 1.488.623 2.317l1.817 1.816c1.113-1.885.81-4.285-.74-5.834-1.492-1.493-3.777-1.83-5.63-.853z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#ffffff",
    xlinkHref: "#u6nx5woq5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOffWhite);
export default __webpack_public_path__ + "static/media/icon-eye-off-white.df4a47f7ccde2372afdc2b8cbe863048.svg";
export { ForwardRef as ReactComponent };